<template>
  <ContactUsModal ref="OpenContactUsModal" />
  <v-container fluid class="container-main">
    <v-row justify="center">
      <v-col cols="12" sm="11">
        <v-row justify="space-between">
          <v-col cols="10" sm="10" align-self="center">
            <h2 class="text-title">
              {{ t(`$vuetify.service.pricing.title`) }}
            </h2>
          </v-col>
          <v-col cols="2" align-self="center">
            <svg width="100%" class="px-md-10" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g class="svg-animation">
                <path
                  d="M62.9163 7.36047C60.8402 7.36047 59.5483 5.9505 59.5483 3.65312V3.64819C59.5483 1.39026 60.8402 0 62.8917 0C64.5781 0 65.6729 0.976138 65.9441 2.28752L65.9638 2.36639H64.6718L64.657 2.31217C64.3858 1.54802 63.7694 1.10432 62.8966 1.10432C61.6145 1.10432 60.8452 2.04102 60.8452 3.63833V3.64326C60.8452 5.27509 61.649 6.25616 62.9311 6.25616C64.0061 6.25616 64.7458 5.59554 64.7705 4.59968L64.7754 4.49122H63.01V3.50029H66.0181V4.26937C66.0181 6.20193 64.8642 7.36047 62.9163 7.36047Z"
                  fill="#101010" />
                <path
                  d="M68.5429 7.44774L69.5789 0.409573L72.3891 0.823031C73.8917 1.04412 74.6861 2.01311 74.4858 3.37392L74.4844 3.38367C74.3451 4.3299 73.725 5.02101 72.8615 5.19794L73.9826 8.2481L72.5483 8.03706L71.5504 5.19938L70.1893 4.99911L69.8016 7.63293L68.5429 7.44774ZM70.3358 4.00411L71.7555 4.21299C72.5507 4.32999 73.0837 3.95993 73.195 3.20393L73.1964 3.19417C73.3048 2.45768 72.8732 1.93573 72.0829 1.81945L70.6876 1.61416L70.3358 4.00411Z"
                  fill="#101010" />
                <path
                  d="M76.8689 8.9292L78.9189 2.11685L83.3294 3.44344L83.0211 4.46789L79.829 3.50775L79.2763 5.3442L82.2938 6.25179L81.9968 7.23847L78.9794 6.33088L78.3955 8.2712L81.5877 9.23134L81.2794 10.2558L76.8689 8.9292Z"
                  fill="#101010" />
                <path
                  d="M84.6055 11.5212L87.6259 5.07987L91.7962 7.03433L91.342 8.00299L88.3236 6.58841L87.5094 8.32484L90.3625 9.662L89.9251 10.5949L87.0719 9.25779L86.2117 11.0924L89.23 12.507L88.7758 13.4757L84.6055 11.5212Z"
                  fill="#101010" />
                <path
                  d="M91.1391 14.7202L95.0654 8.78717L96.0195 9.41826L96.1599 15.4874L96.1846 15.5037L98.9354 11.3469L99.9883 12.0433L96.062 17.9763L95.1161 17.3507L94.9784 11.2596L94.9578 11.246L92.1961 15.4193L91.1391 14.7202Z"
                  fill="#101010" />
                <path
                  d="M98.1082 19.532L101.435 12.9606L102.42 13.8423L99.758 18.6665L99.7763 18.683L104.421 15.6352L105.281 16.4051L102.759 21.3544L102.777 21.3708L107.282 18.1981L108.267 19.0798L102.097 23.1049L101.182 22.2857L103.519 17.5281L103.497 17.5084L99.0227 20.3512L98.1082 19.532Z"
                  fill="#101010" />
                <path
                  d="M105.791 27.3565C104.459 25.7574 104.718 23.8557 106.457 22.4082L106.465 22.4019C108.201 20.9575 110.125 21.0567 111.45 22.6482C112.778 24.2436 112.519 26.1453 110.783 27.5896L110.776 27.5959C109.036 29.0434 107.122 28.9557 105.791 27.3565ZM106.64 26.6501C107.463 27.6392 108.744 27.6059 109.949 26.6031L109.957 26.5968C111.17 25.5876 111.414 24.3323 110.601 23.3546C109.79 22.3807 108.511 22.3862 107.295 23.3985L107.287 23.4048C106.07 24.4171 105.826 25.6724 106.64 26.6501Z"
                  fill="#101010" />
                <path
                  d="M109.316 31.7285L115.39 28.0225L116.87 30.4465C117.661 31.7426 117.424 32.9729 116.25 33.6894L116.242 33.6946C115.425 34.1928 114.497 34.1584 113.809 33.608L112.181 36.4206L111.425 35.1834L112.969 32.6015L112.252 31.4274L109.979 32.8142L109.316 31.7285ZM113.111 30.9034L113.858 32.128C114.277 32.814 114.903 32.9868 115.555 32.5887L115.563 32.5836C116.199 32.1958 116.324 31.5303 115.908 30.8486L115.173 29.645L113.111 30.9034Z"
                  fill="#101010" />
                <path
                  d="M113.503 39.074L120.052 36.2917L120.549 37.4623L114.985 39.8262L116.248 42.7982L115.264 43.2166L113.503 39.074Z"
                  fill="#101010" />
                <path
                  d="M116.309 46.1028L123.193 44.3035L123.851 46.8171C124.387 48.8681 123.466 50.4133 121.29 50.9819L121.281 50.9844C119.101 51.5543 117.505 50.677 116.966 48.6165L116.309 46.1028ZM117.671 47.0616L117.973 48.2158C118.334 49.5991 119.378 50.1415 120.948 49.7312L120.958 49.7287C122.494 49.3272 123.135 48.3291 122.777 46.9602L122.475 45.8059L117.671 47.0616Z"
                  fill="#101010" />
                <path d="M121.236 63.4269L122.33 63.4669L122.213 66.6446L121.119 66.6046L121.236 63.4269Z"
                  fill="#101010" />
                <path
                  d="M116.73 78.5924L123.464 80.8894L122.579 83.4837C122.114 84.8461 120.897 85.4674 119.548 85.0074L119.538 85.0042C118.194 84.5458 117.606 83.3084 118.071 81.946L118.545 80.5555L116.319 79.7962L116.73 78.5924ZM121.696 82.8492L122.069 81.7573L119.516 80.8866L119.143 81.9785C118.849 82.8417 119.143 83.5048 119.951 83.7801L119.96 83.7833C120.768 84.0587 121.402 83.7124 121.696 82.8492Z"
                  fill="#101010" />
                <path
                  d="M114.257 85.5419L119.422 91.057L118.768 92.3285L111.277 91.3381L111.888 90.1499L113.799 90.4558L115.009 88.1014L113.649 86.7256L114.257 85.5419ZM117.975 91.1003L115.736 88.835L114.818 90.6194L117.962 91.1266L117.975 91.1003Z"
                  fill="#101010" />
                <path
                  d="M109.978 93.4024L115.765 97.5417L114.113 99.8512C113.229 101.086 112.004 101.349 110.885 100.549L110.877 100.543C110.099 99.9868 109.767 99.1194 110.005 98.2709L106.779 97.873L107.622 96.6942L110.603 97.1045L111.404 95.9858L109.238 94.4368L109.978 93.4024ZM112.222 96.571L111.387 97.7378C110.919 98.3913 111.005 99.0344 111.626 99.479L111.634 99.4848C112.24 99.9179 112.901 99.7729 113.366 99.1233L114.187 97.9766L112.222 96.571Z"
                  fill="#101010" />
                <path
                  d="M103.851 101.167L108.203 105.362L109.682 103.828L110.452 104.571L106.619 108.546L105.849 107.803L107.324 106.274L102.972 102.079L103.851 101.167Z"
                  fill="#101010" />
                <path
                  d="M99.7152 105.277L104.064 110.908L103.159 111.607L97.3678 109.78L97.3444 109.798L100.391 113.743L99.3922 114.514L95.0432 108.883L95.9409 108.19L101.752 110.027L101.771 110.012L98.7121 106.051L99.7152 105.277Z"
                  fill="#101010" />
                <path
                  d="M92.3997 110.604L95.8823 116.807L91.8658 119.061L91.3421 118.128L94.2491 116.497L93.3103 114.825L90.5624 116.366L90.058 115.468L92.8059 113.926L91.8139 112.159L88.907 113.79L88.3832 112.857L92.3997 110.604Z"
                  fill="#101010" />
                <path
                  d="M85.4408 114.267L87.9827 120.911L85.3298 121.926C83.9112 122.468 82.744 122.012 82.2525 120.727L82.249 120.718C81.9073 119.825 82.1097 118.919 82.776 118.342L80.3052 116.231L81.6593 115.713L83.9187 117.699L85.2037 117.208L84.2524 114.721L85.4408 114.267ZM85.5631 118.147L84.2228 118.66C83.472 118.947 83.1884 119.53 83.4614 120.244L83.465 120.253C83.7309 120.948 84.3628 121.192 85.109 120.907L86.4263 120.403L85.5631 118.147Z"
                  fill="#101010" />
                <path
                  d="M69.4389 118.574L69.9583 125.669L65.4336 126L65.3555 124.933L68.6113 124.695L68.4576 122.595L65.4822 122.813L65.4066 121.781L68.382 121.563L68.17 118.667L69.4389 118.574Z"
                  fill="#101010" />
                <path
                  d="M59.0567 118.629C61.1322 118.781 62.3223 120.287 62.1571 122.544L62.1564 122.554C61.9915 124.806 60.5849 126.121 58.5193 125.97C56.4488 125.819 55.2586 124.313 55.4235 122.061L55.4242 122.051C55.5894 119.794 56.9813 118.477 59.0567 118.629ZM58.9761 119.731C57.6925 119.637 56.8272 120.582 56.7128 122.145L56.712 122.155C56.5969 123.729 57.3311 124.776 58.5999 124.869C59.8639 124.961 60.7474 124.037 60.8629 122.459L60.8636 122.449C60.9792 120.871 60.245 119.824 58.9761 119.731Z"
                  fill="#101010" />
                <path
                  d="M53.4609 118.132L51.9137 125.076L49.1412 124.459C47.6588 124.129 46.9372 123.104 47.2364 121.762L47.2385 121.752C47.4465 120.819 48.1154 120.175 48.9895 120.061L48.0941 116.937L49.5092 117.252L50.2972 120.155L51.6401 120.454L52.2191 117.856L53.4609 118.132ZM51.4213 121.436L50.0207 121.124C49.2361 120.949 48.6775 121.28 48.5113 122.025L48.5092 122.035C48.3473 122.762 48.7396 123.314 49.5194 123.487L50.896 123.794L51.4213 121.436Z"
                  fill="#101010" />
                <path
                  d="M37.7389 112.898L34.2563 119.101L30.2398 116.848L30.7635 115.915L33.6705 117.546L34.6094 115.874L31.8615 114.332L32.3659 113.433L35.1138 114.975L36.1057 113.208L33.1987 111.577L33.7224 110.644L37.7389 112.898Z"
                  fill="#101010" />
                <path
                  d="M31.545 109.299L27.5195 110.72L27.5105 110.731L27.1804 114.918L25.99 113.999L26.319 110.87L26.2761 110.837L23.3359 111.95L22.2079 111.079L26.2592 109.722L26.2682 109.71L26.5881 105.472L27.7474 106.367L27.4779 109.467L27.5131 109.494L30.4483 108.452L31.545 109.299Z"
                  fill="#101010" />
                <path
                  d="M22.8026 101.615C24.223 103.088 24.1045 104.996 22.4679 106.574L22.4644 106.577C20.8278 108.155 18.9194 108.193 17.5024 106.724C16.3661 105.545 16.2658 103.971 17.1795 102.83L17.2116 102.792L18.0775 103.69L18.0272 103.773C17.5852 104.487 17.6542 105.29 18.2976 105.957C19.1602 106.851 20.4248 106.735 21.5608 105.64L21.5643 105.637C22.7039 104.538 22.8665 103.272 22.0074 102.381C21.3777 101.728 20.5847 101.609 19.7919 102.051L19.7461 102.075L18.8802 101.177L18.9226 101.15C20.1 100.268 21.6663 100.437 22.8026 101.615Z"
                  fill="#101010" />
                <path
                  d="M18.9726 97.4558L13.1854 101.595L12.4451 100.561L17.362 97.0438L15.4826 94.4176L16.3529 93.7951L18.9726 97.4558Z"
                  fill="#101010" />
                <path
                  d="M13.4756 88.5443C14.3009 90.149 13.8721 91.6333 12.4731 92.3524L8.37697 94.4578L7.79523 93.3266L11.7993 91.2686C12.6764 90.8177 12.9758 89.9875 12.4933 89.0492C12.0108 88.111 11.1634 87.8757 10.2863 88.3266L6.28227 90.3847L5.7028 89.2579L9.79892 87.1525C11.1979 86.4334 12.6481 86.9352 13.4756 88.5443Z"
                  fill="#101010" />
                <path
                  d="M10.3355 81.1851C10.8625 82.7295 10.4816 83.995 9.29983 84.4866L9.23142 84.5151L8.83814 83.3627L8.89096 83.3342C9.43944 83.0482 9.5966 82.333 9.30841 81.4885C9.01863 80.6393 8.45908 80.2363 7.88035 80.4337L7.87568 80.4353C7.37163 80.6072 7.22035 81.0495 7.33448 81.9794L7.43193 82.7536C7.60875 84.1726 7.2156 85.036 6.21216 85.3782L6.2075 85.3798C5.02045 85.7795 3.86264 85.0127 3.36747 83.5616C2.86592 82.0919 3.31267 80.8664 4.44157 80.4033L4.51932 80.3716L4.9126 81.524L4.85978 81.5525C4.29878 81.8324 4.12548 82.4697 4.38342 83.2255C4.65717 84.0125 5.19306 84.3767 5.72978 84.1936L5.73444 84.192C6.21049 84.0297 6.36474 83.5655 6.25571 82.6964L6.15667 81.9175C5.96837 80.4191 6.32919 79.6136 7.37929 79.2555L7.38396 79.2539C8.63942 78.8257 9.77505 79.5427 10.3355 81.1851Z"
                  fill="#101010" />
                <path d="M8.26745 74.0505L1.27001 75.3426L1.03892 74.0919L8.03636 72.7997L8.26745 74.0505Z"
                  fill="#101010" />
                <path
                  d="M7.25514 66.0693L0.234131 68.7925L0.183523 67.4081L5.87347 65.3946L5.87257 65.37L0.0506083 63.7722L0 62.3878L7.20129 64.5962L7.25514 66.0693Z"
                  fill="#101010" />
                <path
                  d="M7.26112 59.289L0.188003 58.5109L0.691746 53.9339L1.75541 54.0509L1.39082 57.3636L3.29757 57.5734L3.64221 54.442L4.66666 54.5547L4.32202 57.6861L6.33661 57.9077L6.7012 54.595L7.76486 54.712L7.26112 59.289Z"
                  fill="#101010" />
                <path
                  d="M11.6888 41.4088C11.0504 42.9106 9.92194 43.599 8.71369 43.1767L8.64368 43.1523L9.12006 42.0316L9.17837 42.0457C9.77779 42.1986 10.3722 41.7708 10.7213 40.9495C11.0723 40.1237 10.9245 39.4503 10.3618 39.2112L10.3572 39.2093C9.86707 39.0011 9.45919 39.2295 8.92346 39.9983L8.47929 40.6398C7.66379 41.8147 6.7947 42.1954 5.81893 41.7808L5.8144 41.7789C4.66355 41.2846 4.31302 39.9412 4.91283 38.5301C5.52035 37.1008 6.67104 36.4862 7.82097 36.8944L7.90005 36.9226L7.42368 38.0433L7.36536 38.0293C6.76072 37.8635 6.20626 38.2225 5.89382 38.9575C5.57242 39.7263 5.72845 40.355 6.25037 40.5768L6.25491 40.5787C6.71784 40.7754 7.14251 40.5326 7.64147 39.8125L8.08757 39.1664C8.94755 37.9248 9.75389 37.5656 10.775 37.9994L10.7796 38.0014C12.0004 38.52 12.3676 39.8116 11.6888 41.4088Z"
                  fill="#101010" />
                <path
                  d="M14.1369 35.9827L8.06294 32.2767L10.4623 28.3463L11.3757 28.9036L9.63913 31.7483L11.2765 32.7474L12.9181 30.0583L13.7978 30.5951L12.1563 33.2841L13.8863 34.3397L15.6229 31.4949L16.5363 32.0522L14.1369 35.9827Z"
                  fill="#101010" />
                <path
                  d="M18.4123 29.3833L12.9428 24.8326L14.7597 22.6499C15.7312 21.4828 16.9724 21.3096 18.0299 22.1895L18.0375 22.1958C18.7729 22.8076 19.0399 23.6968 18.7412 24.5258L21.9294 25.158L21.0021 26.2721L18.0594 25.6454L17.1793 26.7027L19.2261 28.4056L18.4123 29.3833ZM16.4061 26.0593L17.324 24.9566C17.8382 24.3389 17.7999 23.6913 17.2123 23.2025L17.2048 23.1962C16.6324 22.72 15.962 22.8164 15.4509 23.4303L14.5488 24.5141L16.4061 26.0593Z"
                  fill="#101010" />
                <path
                  d="M25.0411 22.1304L18.4562 18.4771L19.4883 17.5526L24.676 20.6371L24.6944 20.6206L22.1987 15.1247L23.2307 14.2002L26.1392 21.1467L25.0411 22.1304Z"
                  fill="#101010" />
                <path d="M31.4966 16.9786L27.5704 11.0456L28.6314 10.3438L32.5577 16.2768L31.4966 16.9786Z"
                  fill="#101010" />
                <path
                  d="M39.5182 12.5602C37.6652 13.4286 35.8968 12.7002 34.9318 10.6424L34.9297 10.6379C33.9648 8.58007 34.5447 6.762 36.3932 5.89567C37.8756 5.20094 39.3983 5.61436 40.1833 6.84722L40.2087 6.88976L39.0791 7.41919L39.017 7.34483C38.4841 6.69619 37.7015 6.50217 36.862 6.89557C35.7369 7.4229 35.4387 8.65704 36.1085 10.0855L36.1106 10.0899C36.7825 11.5228 37.9286 12.0855 39.0493 11.5603C39.8709 11.1753 40.2397 10.4634 40.0769 9.57048L40.0694 9.51956L41.1991 8.99014L41.2111 9.03897C41.6654 10.4377 41.0006 11.8655 39.5182 12.5602Z"
                  fill="#101010" />
                <path
                  d="M44.6921 10.2795L42.642 3.46716L47.0525 2.14057L47.3608 3.16502L44.1686 4.12516L44.7213 5.96161L47.7388 5.05402L48.0357 6.0407L45.0182 6.94829L45.6021 8.88861L48.7943 7.92846L49.1026 8.95291L44.6921 10.2795Z"
                  fill="#101010" />
                <path
                  d="M54.7728 7.97462C53.1579 8.21221 51.9824 7.60781 51.7135 6.35676L51.6978 6.28431L52.9029 6.10701L52.9212 6.16411C53.103 6.75527 53.7778 7.03967 54.6609 6.90975C55.5488 6.77911 56.0468 6.30221 55.9578 5.6974L55.9571 5.69252C55.8795 5.16576 55.472 4.9367 54.5365 4.87999L53.7574 4.83518C52.3295 4.75127 51.5517 4.20793 51.3973 3.15928L51.3966 3.1544C51.2191 1.91481 52.1835 0.91582 53.7008 0.692582C55.2376 0.466472 56.3618 1.12826 56.6123 2.32222L56.6294 2.40442L55.4244 2.58172L55.406 2.52463C55.2326 1.92227 54.6372 1.63614 53.8469 1.75242C53.0231 1.87861 52.5675 2.3393 52.6501 2.90021L52.6508 2.90509C52.7241 3.40259 53.1526 3.63853 54.0273 3.68921L54.8114 3.73332C56.3195 3.82037 57.0462 4.32139 57.2077 5.41882L57.2085 5.42369C57.4016 6.73573 56.4901 7.72195 54.7728 7.97462Z"
                  fill="#101010" />
              </g>
              <g>
                <path
                  d="M62 47C59.4288 47 56.9154 47.7624 54.7776 49.1909C52.6398 50.6194 50.9735 52.6497 49.9896 55.0251C49.0056 57.4006 48.7482 60.0144 49.2498 62.5362C49.7514 65.0579 50.9895 67.3743 52.8076 69.1924C54.6257 71.0105 56.9421 72.2486 59.4638 72.7502C61.9856 73.2518 64.5995 72.9944 66.9749 72.0104C69.3503 71.0265 71.3807 69.3603 72.8091 67.2224C74.2376 65.0846 75 62.5712 75 60C74.9964 56.5533 73.6256 53.2488 71.1884 50.8116C68.7512 48.3744 65.4467 47.0036 62 47ZM62 57C62.2652 57 62.5196 57.1054 62.7071 57.2929C62.8946 57.4804 63 57.7348 63 58C63 58.2652 62.8946 58.5196 62.7071 58.7071C62.5196 58.8946 62.2652 59 62 59H57V61H61C61.2652 61 61.5196 61.1054 61.7071 61.2929C61.8946 61.4804 62 61.7348 62 62C62 62.2652 61.8946 62.5196 61.7071 62.7071C61.5196 62.8946 61.2652 63 61 63H57.2363C57.5197 63.8928 58.0253 64.6991 58.7056 65.3431C59.3859 65.9871 60.2187 66.4477 61.1257 66.6818C62.0327 66.916 62.9844 66.9159 63.8914 66.6816C64.7984 66.4474 65.631 65.9866 66.3113 65.3425C66.4051 65.2458 66.5176 65.169 66.6419 65.1168C66.7663 65.0647 66.8998 65.0382 67.0346 65.039C67.1695 65.0398 67.3027 65.0678 67.4264 65.1214C67.5501 65.175 67.6617 65.2531 67.7545 65.3509C67.8472 65.4487 67.9193 65.5643 67.9662 65.6906C68.0132 65.817 68.0341 65.9516 68.0277 66.0862C68.0214 66.2209 67.9878 66.3529 67.9291 66.4742C67.8705 66.5956 67.7878 66.7039 67.6863 66.7925C66.722 67.7059 65.5333 68.348 64.2407 68.6535C62.9481 68.9589 61.5977 68.917 60.3265 68.5318C59.0554 68.1466 57.9088 67.432 57.0032 66.4605C56.0975 65.4889 55.4651 64.295 55.17 63H54C53.7348 63 53.4804 62.8946 53.2929 62.7071C53.1054 62.5196 53 62.2652 53 62C53 61.7348 53.1054 61.4804 53.2929 61.2929C53.4804 61.1054 53.7348 61 54 61H55V59H54C53.7348 59 53.4804 58.8946 53.2929 58.7071C53.1054 58.5196 53 58.2652 53 58C53 57.7348 53.1054 57.4804 53.2929 57.2929C53.4804 57.1054 53.7348 57 54 57H55.14C55.4119 55.6869 56.0297 54.4703 56.9295 53.476C57.8293 52.4817 58.9784 51.7459 60.258 51.3447C61.5375 50.9434 62.901 50.8914 64.2074 51.1938C65.5138 51.4963 66.7157 52.1423 67.6888 53.065C67.7903 53.1536 67.873 53.2619 67.9316 53.3833C67.9903 53.5046 68.0239 53.6366 68.0302 53.7713C68.0366 53.9059 68.0157 54.0405 67.9687 54.1669C67.9218 54.2932 67.8497 54.4088 67.757 54.5066C67.6642 54.6044 67.5526 54.6825 67.4289 54.7361C67.3052 54.7897 67.172 54.8177 67.0371 54.8185C66.9023 54.8193 66.7688 54.7928 66.6444 54.7407C66.5201 54.6885 66.4076 54.6117 66.3138 54.515C65.6245 53.8617 64.7787 53.397 63.8578 53.1655C62.9368 52.9339 61.9718 52.9435 61.0556 53.1932C60.1394 53.4428 59.3029 53.9242 58.6267 54.591C57.9506 55.2577 57.4575 56.0874 57.195 57H62Z"
                  fill="#343330" />
              </g>
            </svg>
          </v-col>
        </v-row>
        <v-divider class="divider-bottom my-15" color="info"></v-divider>

        <v-row justify="center">
          <!-- Gold -->
          <v-col cols="12" sm="6" md="3" class="pa-1">
            <v-card @click="OpenModal('Gold Pack')" class="card-pack pa-3 px-md-1  py-lg-4 px-lg-2" color="#EBEBEB" flat width="100%">
              <div>
                <v-card-title class="card-pack-title fontRaleway pr-md-0">
                  {{ t(`$vuetify.service.pricing.gold_pack.title`) }}
                </v-card-title>
                <v-card-text class="card-pack-text fontSFProR">
                  {{ t(`$vuetify.service.pricing.gold_pack.description`) }}
                </v-card-text>
                <div class="card-pack-price py-4 fontSFProR">
                  <sup class="card-pack-price-1">€</sup>
                  <span class="card-pack-price-2">
                    8000
                  </span>
                  <small class="card-pack-price-3">
                    /{{ t(`$vuetify.service.pricing.gold_pack.price_type`) }}
                  </small>
                </div>
                <v-row class="ma-0">
                  <v-col cols="auto">
                    <div class="card-pack-plus-price fontSFProR px-4 py-1">
                      + {{ t(`$vuetify.service.pricing.gold_pack.plus_price_car`) }}
                    </div>
                  </v-col>
                </v-row>
              </div>
              <v-row class="ma-0" justify="center">
                <v-col cols="12" align-self="end">
                  <v-btn block variant="flat" class="fontSFProR card-pack-btn" color="#101010">
                    {{ t(`$vuetify.service.pricing.gold_pack.btn_request_now`) }}
                    <template v-slot:append>
                      <v-icon>
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 0.386127V7.079C9 7.1814 8.95932 7.27962 8.88691 7.35203C8.81449 7.42444 8.71628 7.46512 8.61387 7.46512C8.51147 7.46512 8.41325 7.42444 8.34084 7.35203C8.26843 7.27962 8.22775 7.1814 8.22775 7.079V1.31798L0.649358 8.89637C0.576162 8.96457 0.479349 9.00171 0.379316 8.99994C0.279282 8.99818 0.183839 8.95765 0.113094 8.88691C0.0423488 8.81616 0.00182513 8.72072 6.01572e-05 8.62068C-0.00170481 8.52065 0.0354267 8.42384 0.103632 8.35064L7.68202 0.772254H1.921C1.8186 0.772254 1.72038 0.731573 1.64797 0.65916C1.57556 0.586747 1.53488 0.488534 1.53488 0.386127C1.53488 0.28372 1.57556 0.185507 1.64797 0.113094C1.72038 0.0406811 1.8186 0 1.921 0H8.61387C8.71628 0 8.81449 0.0406811 8.88691 0.113094C8.95932 0.185507 9 0.28372 9 0.386127Z"
                            fill="#EEAC47" />
                        </svg>
                      </v-icon>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- Silver -->
          <v-col cols="12" sm="6" md="3" class="pa-1">
            <v-card @click="OpenModal('Silver Pack')" class="card-pack pa-3 px-md-1  py-lg-4 px-lg-2" color="#EBEBEB" flat width="100%">
              <div>
                <v-card-title class="card-pack-title fontRaleway pr-md-0">
                  {{ t(`$vuetify.service.pricing.silver_pack.title`) }}
                </v-card-title>
                <v-card-text class="card-pack-text fontSFProR">
                  {{ t(`$vuetify.service.pricing.silver_pack.description`) }}
                </v-card-text>
                <div class="card-pack-price py-4 fontSFProR">
                  <sup class="card-pack-price-1">€</sup>
                  <span class="card-pack-price-2">
                    3000
                  </span>
                  <small class="card-pack-price-3">
                    /{{ t(`$vuetify.service.pricing.silver_pack.price_type`) }}
                  </small>
                </div>
                <v-row class="ma-0">
                  <v-col cols="auto">
                    <div class="card-pack-plus-price fontSFProR px-4 py-1">
                      + {{ t(`$vuetify.service.pricing.silver_pack.plus_price_car`) }}
                    </div>
                  </v-col>
                </v-row>
              </div>
              <v-row class="ma-0" justify="center">
                <v-col cols="12" align-self="end">
                  <v-btn block variant="flat" class="fontSFProR card-pack-btn" color="#101010">
                    {{ t(`$vuetify.service.pricing.silver_pack.btn_request_now`) }}
                    <template v-slot:append>
                      <v-icon>
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 0.386127V7.079C9 7.1814 8.95932 7.27962 8.88691 7.35203C8.81449 7.42444 8.71628 7.46512 8.61387 7.46512C8.51147 7.46512 8.41325 7.42444 8.34084 7.35203C8.26843 7.27962 8.22775 7.1814 8.22775 7.079V1.31798L0.649358 8.89637C0.576162 8.96457 0.479349 9.00171 0.379316 8.99994C0.279282 8.99818 0.183839 8.95765 0.113094 8.88691C0.0423488 8.81616 0.00182513 8.72072 6.01572e-05 8.62068C-0.00170481 8.52065 0.0354267 8.42384 0.103632 8.35064L7.68202 0.772254H1.921C1.8186 0.772254 1.72038 0.731573 1.64797 0.65916C1.57556 0.586747 1.53488 0.488534 1.53488 0.386127C1.53488 0.28372 1.57556 0.185507 1.64797 0.113094C1.72038 0.0406811 1.8186 0 1.921 0H8.61387C8.71628 0 8.81449 0.0406811 8.88691 0.113094C8.95932 0.185507 9 0.28372 9 0.386127Z"
                            fill="#EEAC47" />
                        </svg>
                      </v-icon>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- Bronze -->
          <v-col cols="12" sm="6" md="3" class="pa-1">
            <v-card @click="OpenModal('Bronze Pack')" class="card-pack pa-3 px-md-1  py-lg-4 px-lg-2" color="#EBEBEB" flat width="100%">
              <div>
                <v-card-title class="card-pack-title fontRaleway pr-md-0">
                  {{ t(`$vuetify.service.pricing.bronze_pack.title`) }}
                </v-card-title>
                <v-card-text class="card-pack-text fontSFProR">
                  {{ t(`$vuetify.service.pricing.bronze_pack.description`) }}
                </v-card-text>
                <div class="card-pack-price py-4 fontSFProR">
                  <sup class="card-pack-price-1">€</sup>
                  <span class="card-pack-price-2">
                    500
                  </span>
                  <small class="card-pack-price-3">
                    /{{ t(`$vuetify.service.pricing.bronze_pack.price_type`) }}
                  </small>
                </div>
                <v-row class="ma-0">
                  <v-col cols="auto">
                    <div class="card-pack-plus-price fontSFProR px-4 py-1">
                      + {{ t(`$vuetify.service.pricing.bronze_pack.plus_price_car`) }}
                    </div>
                  </v-col>
                </v-row>
              </div>
              <v-row class="ma-0" justify="center">
                <v-col cols="12" align-self="end">
                  <v-btn block variant="flat" class="fontSFProR card-pack-btn" color="#101010">
                    {{ t(`$vuetify.service.pricing.bronze_pack.btn_request_now`) }}
                    <template v-slot:append>
                      <v-icon>
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 0.386127V7.079C9 7.1814 8.95932 7.27962 8.88691 7.35203C8.81449 7.42444 8.71628 7.46512 8.61387 7.46512C8.51147 7.46512 8.41325 7.42444 8.34084 7.35203C8.26843 7.27962 8.22775 7.1814 8.22775 7.079V1.31798L0.649358 8.89637C0.576162 8.96457 0.479349 9.00171 0.379316 8.99994C0.279282 8.99818 0.183839 8.95765 0.113094 8.88691C0.0423488 8.81616 0.00182513 8.72072 6.01572e-05 8.62068C-0.00170481 8.52065 0.0354267 8.42384 0.103632 8.35064L7.68202 0.772254H1.921C1.8186 0.772254 1.72038 0.731573 1.64797 0.65916C1.57556 0.586747 1.53488 0.488534 1.53488 0.386127C1.53488 0.28372 1.57556 0.185507 1.64797 0.113094C1.72038 0.0406811 1.8186 0 1.921 0H8.61387C8.71628 0 8.81449 0.0406811 8.88691 0.113094C8.95932 0.185507 9 0.28372 9 0.386127Z"
                            fill="#EEAC47" />
                        </svg>
                      </v-icon>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- individual -->
          <v-col cols="12" sm="6" md="3" class="pa-1">
            <v-card @click="OpenModal('Individual Pack')" class="card-pack pa-3 px-md-1  py-lg-4 px-lg-2" color="#EBEBEB" flat width="100%">
              <div style="display: flex; flex-wrap: wrap; flex: 1 1 auto;">
                <v-card-title class="card-pack-title fontRaleway pr-md-0">
                  {{ t(`$vuetify.service.pricing.individual_pack.title`) }}
                </v-card-title>
                <v-card-text class="card-pack-text fontSFProR">
                  {{ t(`$vuetify.service.pricing.individual_pack.description`) }}
                </v-card-text>
                <!-- <div class="card-pack-price py-4 fontSFProR">
                  <sup class="card-pack-price-1">€</sup>
                  <span class="card-pack-price-2">
                    8000
                  </span>
                  <small class="card-pack-price-3">
                    /per month
                  </small>
                </div>
                <v-row class="ma-0">
                  <v-col cols="auto">
                    <div class="card-pack-plus-price fontSFProR px-4 py-1">
                      + Price for the specific car.
                    </div>
                  </v-col>
                </v-row> -->
              </div>
              <v-row class="ma-0" justify="center">
                <v-col cols="12" align-self="end">
                  <v-btn block variant="flat" class="fontSFProR card-pack-btn" color="#101010">
                    {{ t(`$vuetify.service.pricing.individual_pack.btn_request_now`) }}
                    <template v-slot:append>
                      <v-icon>
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 0.386127V7.079C9 7.1814 8.95932 7.27962 8.88691 7.35203C8.81449 7.42444 8.71628 7.46512 8.61387 7.46512C8.51147 7.46512 8.41325 7.42444 8.34084 7.35203C8.26843 7.27962 8.22775 7.1814 8.22775 7.079V1.31798L0.649358 8.89637C0.576162 8.96457 0.479349 9.00171 0.379316 8.99994C0.279282 8.99818 0.183839 8.95765 0.113094 8.88691C0.0423488 8.81616 0.00182513 8.72072 6.01572e-05 8.62068C-0.00170481 8.52065 0.0354267 8.42384 0.103632 8.35064L7.68202 0.772254H1.921C1.8186 0.772254 1.72038 0.731573 1.64797 0.65916C1.57556 0.586747 1.53488 0.488534 1.53488 0.386127C1.53488 0.28372 1.57556 0.185507 1.64797 0.113094C1.72038 0.0406811 1.8186 0 1.921 0H8.61387C8.71628 0 8.81449 0.0406811 8.88691 0.113094C8.95932 0.185507 9 0.28372 9 0.386127Z"
                            fill="#EEAC47" />
                        </svg>
                      </v-icon>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "../Modals/ContactUsModal.vue";

export default {
  name: 'PricingPage',
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  components: {
    ContactUsModal
  },
  methods: {
    OpenModal() {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
  }
}
</script>

<style scoped>
.card-pack-btn {
  border-radius: 5px;
  box-shadow: 5px 18px 50px 0px rgba(0, 0, 0, 0.25);
  text-transform: initial;
  letter-spacing: 0px;
  font-size: 1rem;
  justify-content: space-between;
}

.card-pack-plus-price {
  color: #101010;
  text-align: center;
  font-size: 1rem;
  border-radius: 15px;
  border: 1px solid rgba(16, 16, 16, 0.10);
}

.card-pack-price-3 {
  font-size: 1rem;
  font-weight: 400;
}

.card-pack-price-2 {
  font-size: 2rem;
  font-weight: 400;
}

.card-pack-price-1 {
  font-size: 1rem;
  font-weight: 400;
}

.card-pack-price {
  color: #101010;
  font-size: 1rem;
  padding-left: 15px;
  padding-right: 15px;
}

.card-pack-text {
  color: #101010;
  font-size: 15px;
  font-weight: 400;
  text-wrap: balance;
  white-space: normal;
}

.card-pack-title {
  color: #101010;
  font-size: 1.8rem;
  line-height: 2.3rem;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-wrap: balance;
  white-space: normal;
}

.card-pack {
  height: 100%;
  min-height: 325px;
  border-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: .7s;
}

.card-pack:hover {
  background: #101010 !important;
  cursor: pointer;
  box-shadow: 5px 18px 50px 0px rgba(0, 0, 0, 0.25);
}

.card-pack:hover .card-pack-title {
  color: #EEAC47;
}

.card-pack:hover .card-pack-text,
.card-pack:hover .card-pack-price,
.card-pack:hover .card-pack-price-1,
.card-pack:hover .card-pack-price-2,
.card-pack:hover .card-pack-price-3,
.card-pack:hover .card-pack-plus-price {
  color: #E6E8EB;
}

.card-pack:hover .card-pack-btn {
  background: #E6E8EB !important;
  color: #101010 !important;
}

.divider-bottom {
  border-width: 1px;
  border-color: rgba(154, 154, 155, 0.36);
  opacity: 1;
}

.navi-title {
  color: #030712;
  font-size: 3.5rem;
  letter-spacing: .08rem;
  font-weight: 400;
  text-transform: uppercase;
}

.navi-description {
  color: #4C4C4C;
  font-size: 1.4rem;
}

.text-title {
  color: #343330;
  font-weight: 300;
  font-size: 5.5rem;
  line-height: 7rem;
  text-align: left;
  text-transform: uppercase;
}

@media (min-width: 600px) and (max-width: 960px) {
  .text-title {
    font-size: 3.8rem;
    font-weight: 300;
    line-height: 5rem;
  }

}

@media (max-width: 600px) {
  .text-title {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 3rem;
  }
}

.svg-animation {
  overflow: visible;
  transform-origin: 50% 50%;
  animation-name: svg-anim-navigation;
  animation-duration: 18s;
  animation-direction: normal;
  animation-timing-function: linear;
  transform: rotate(0deg);
  animation-iteration-count: infinite;
}

@keyframes svg-anim-navigation {
  from {
    transform: rotate(-360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

.container-main {
  padding-top: 10vh;
  padding-bottom: 5vh;
}
</style>
